import React from 'react'

import HintPopover from "../../../../../../core/gd-ui/hint-popover/hint-popover"

type Props = {
    projectId: ID
}

export default function AutomationsSubmenuButton(props: Props) {

    const onClick = () => {
        gd.goTo('p/{0}/info/automations'.f(props.projectId))
    }

    return (
        <div className="m-r-10" onClick={onClick}>
            <div className="ui5-control-button fs-14 s-28 i5-automation ui5-color-not-important"/>
            <HintPopover hint="Automations"/>
        </div>
    )
}
